import { INotificationBase } from '../../models/notifications';
import wbsBookingsApi from '../apis/wbsBookingsApi';

interface IListNotificationsProps {
  isUnread?: boolean;
}

export const listNotifications = async ({
  isUnread,
}: IListNotificationsProps): Promise<INotificationBase[]> => {
  const { data } = await wbsBookingsApi.get<INotificationBase[]>(
    '/notifications',
    {
      params: { isUnread },
    },
  );

  return data;
};
